import moment from 'moment';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../constants';

const dateTimeHuman = (dateTime, withTime = false) => {
    const format = withTime ? DATE_TIME_FORMAT : DATE_FORMAT;

    return moment(dateTime).format(format);
};

export default dateTimeHuman;
